import React, { useState, useEffect, Fragment, useContext } from 'react';
import { Container, Row, Col, Input, Button, FormGroup, Progress, UncontrolledPopover, PopoverBody } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { ProjectContext } from '../../../../../context/Project';
import SpaceSelection from './SpaceSelection';
import MaterialSelection from './MaterialSelection';
import TotalEstimationSticky from './Totals/TotalEstimationSticky';
import Totals from './Totals';
import '../steps.scss';
import ContinueButton from './ContinueButton';
import { APPConstants } from '../../../../../constants/app';

function EstimateBudget() {
	const navigate = useNavigate();
	const { getPostalCode, getType, getArea, setArea } = useContext(ProjectContext);

	const [spaceArea, setSpaceArea] = useState('');
	const [space, setSpace] = useState(null);

	const [spaceChanged, setSpaceChanged] = useState(null);

	useEffect(() => {
		if (!getPostalCode()) {
			navigate('/project/create/location');
		} else {
			let type = getType();
			let area = getArea();
			
			if (type) {
				setSpace(type);
			}

			if (area) {
				setSpaceArea(area);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setArea(spaceArea);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [spaceArea]);

	const handleSpaceChange = (space) => {
        setSpace(space);
		setSpaceChanged(space);
    }

	const handleAreaChange = (event) => {
        setSpaceArea(event.target.value);
    }

    return (
    	<Fragment>
	        <nav id="topbar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="cont-topbar">
		    					<Button className="btn-back" onClick={() => navigate(-1)}></Button>
		    					<h3>Estimated budget</h3>
		    				</div>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={32}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
	    	<form className="m-t-20 form-base-dis">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<h1>Pitch your project and get an<br /> estimated budget</h1>

		    				<span className="text-label m-t-20">Choose the space</span>
		    			</Col>
			    	</Row>
		    	</Container>

		    	<SpaceSelection onSpaceChange={ handleSpaceChange }/>

	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<span className="text-label m-t-40">Footprint of the space</span>
							<span className="question-tooltip" id="footprint-tooltip"></span>
							<UncontrolledPopover
								placement="bottom"
								target="footprint-tooltip"
								trigger="legacy"
								className='footprint-tooltip-popover'
							>
								<PopoverBody>
									Enter approximate sqft of the space
								</PopoverBody>
							</UncontrolledPopover>
		    				<div className="m-t-10">
							  <Input value={spaceArea} onChange={handleAreaChange} className="doble-input" placeholder="sq/ft"/>
							</div>
		    			</Col>
			    	</Row>

			    	<MaterialSelection selectedType={ space } spaceChanged={ spaceChanged }/>

			    	<Row className="m-t-70">
			    		<Col xs={{size: 12}}>
			    			<section id="estimated-budget" className="m-b-100">
			    			<div className="same-quality-switch-cont">
								{
								APPConstants.FIX_QUALITY_ENABLE &&
								<Fragment>
									<span className="text-label same-quality-text">Same quality for all materials</span>
									<FormGroup switch>
									<Input type="switch" role="switch" />
									</FormGroup>
								</Fragment>
								}
			    			</div>
			    			<hr/>
			    			{/*TOTAL ESTIMATED STEP 2D*/}
			    			{/*<ul className="total-table">
			    				<li className="materials">
			    					<span className="grey">Materials</span>
			    					<span className="grey">$690</span>
			    				</li>
			    				<li className="labor-cost">
			    					<span className="grey">Labor cost</span>
			    					<span className="grey">$540</span>
			    				</li>
			    				<li className="total-estimated">
			    					<span>Total estimated</span>
			    					<span>$1.230</span>
			    				</li>
			    			</ul>*/}

			    			{/*TOTAL ESTIMATED STEP 2G*/}
							<Totals />
			    			
			    			<div className="d-grid gap-2">
								<ContinueButton className="continue m-t-40 m-b-50"/>
			    			</div>
							
			    			</section>
			    		</Col>
			    	</Row>
		    	</Container>
    			
				<TotalEstimationSticky/>

    			{/*BUTTON "DONE" STEP 2D*/}
    			{/*<Button color="secondary" size="lg" className="button-fixed-fullwidth">Done</Button>*/}
	    	</form>
    	</Fragment>
    );
}

export default EstimateBudget;